// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1-zAc","item":"PaymentsMobile_item__13eR5","label":"PaymentsMobile_label__xJqbz","amount":"PaymentsMobile_amount__2MznV"};